//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class UtilityApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://az-api-dev.ractest.com.au/mcmockutility/api/v1";
    }

    /**
     * GetPersonByShieldContactId
     * @param externalSystemId The shield contact id for the member
     * @param shieldEnvironment Target shield environment
     * @return Person details
     */
    getpersonbyshieldcontactid(externalSystemId: string, shieldEnvironment: string): Promise<ApiResponse<Person>> {
        let url_ = this.baseUrl + "/get-person?";
        if (externalSystemId === undefined || externalSystemId === null)
            throw new Error("The parameter 'externalSystemId' must be defined and cannot be null.");
        else
            url_ += "ExternalSystemId=" + encodeURIComponent("" + externalSystemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetpersonbyshieldcontactid(_response);
        });
    }

    protected processGetpersonbyshieldcontactid(response: Response): Promise<ApiResponse<Person>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Person;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Person does not exist in shield", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Person>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * UpdatePerson
     * @param personId The person/crm id of the person to be updated.
     * @param shieldEnvironment Target shield environment
     * @param personRequest (optional) 
     * @return Person details
     */
    updateperson(personId: string, shieldEnvironment: string, personRequest?: PersonRequest | null | undefined): Promise<ApiResponse<Person>> {
        let url_ = this.baseUrl + "/person/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateperson(_response);
        });
    }

    protected processUpdateperson(response: Response): Promise<ApiResponse<Person>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Person;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Person does not exist in the mock", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Person>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * ClearMembers
     * @param shieldEnvironment Target shield environment
     * @return No content
     */
    clearmembers(shieldEnvironment: string): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/clear";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClearmembers(_response);
        });
    }

    protected processClearmembers(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * SetIsAlive
     * @param shieldEnvironment Target shield environment
     * @param setIsAliveStatus (optional) The status code used to set the is-alive return status for a MC environment.
     * @return No content
     */
    setisalive(shieldEnvironment: string, setIsAliveStatus?: SetIsAliveStatus | null | undefined): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/is-alive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setIsAliveStatus);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetisalive(_response);
        });
    }

    protected processSetisalive(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetIsAlive
     * @param shieldEnvironment Target shield environment
     * @return No content
     */
    getisalive(shieldEnvironment: string): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/is-alive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetisalive(_response);
        });
    }

    protected processGetisalive(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * CreatePerson
     * @param shieldEnvironment Target shield environment
     * @param personRequest (optional) 
     * @return Person created
     */
    createperson(shieldEnvironment: string, personRequest?: PersonRequest | null | undefined): Promise<ApiResponse<Person>> {
        let url_ = this.baseUrl + "/person";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateperson(_response);
        });
    }

    protected processCreateperson(response: Response): Promise<ApiResponse<Person>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Person;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Person>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * SetMemberMatchResult
     * @param shieldEnvironment Target shield environment
     * @param setMatchStatus (optional) The details used to set the return status for a member.
     * @return No content
     */
    setmembermatchresult(shieldEnvironment: string, setMatchStatus?: SetMatchStatus | null | undefined): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setMatchStatus);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetmembermatchresult(_response);
        });
    }

    protected processSetmembermatchresult(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found - contact has not been previously created within the mock.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * SearchMembers
     * @param shieldEnvironment Target shield environment
     * @return Retrieved successfully.
     */
    searchmembers(shieldEnvironment: string): Promise<ApiResponse<MockMember[]>> {
        let url_ = this.baseUrl + "/search";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchmembers(_response);
        });
    }

    protected processSearchmembers(response: Response): Promise<ApiResponse<MockMember[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MockMember[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<MockMember[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * SetProductHoldingResponse
     * @param shieldEnvironment Target shield environment
     * @param setProductHoldingStatus (optional) The status code used to set the product holding return status for a MC environment.
     * @return No content
     */
    setproductholdingresponse(shieldEnvironment: string, setProductHoldingStatus?: SetProductHoldingStatus | null | undefined): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/productholding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setProductHoldingStatus);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetproductholdingresponse(_response);
        });
    }

    protected processSetproductholdingresponse(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetProductHoldingResponse
     * @param shieldEnvironment Target shield environment
     * @return Accepted
     */
    getproductholdingresponse(shieldEnvironment: string): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/productholding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetproductholdingresponse(_response);
        });
    }

    protected processGetproductholdingresponse(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * SetStatusOverrideResponse
     * @param shieldEnvironment Target shield environment
     * @param setStatusOverrideStatus (optional) The status code used to set the product holding return status for a MC environment.
     * @return No content
     */
    setstatusoverrideresponse(shieldEnvironment: string, setStatusOverrideStatus?: SetStatusOverrideStatus | null | undefined): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/statusOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setStatusOverrideStatus);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetstatusoverrideresponse(_response);
        });
    }

    protected processSetstatusoverrideresponse(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetStatusOverrideResponse
     * @param shieldEnvironment Target shield environment
     * @return Accepted
     */
    getstatusoverrideresponse(shieldEnvironment: string): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/statusOverride";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetstatusoverrideresponse(_response);
        });
    }

    protected processGetstatusoverrideresponse(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetPersonProductHoldings
     * @param externalSystemId The shield contact id for the member
     * @param shieldEnvironment Target shield environment
     * @return Product Holding Payloads
     */
    getpersonproductholdings(externalSystemId: string, shieldEnvironment: string): Promise<ApiResponse<PersonProductHolding[]>> {
        let url_ = this.baseUrl + "/personproductholdings?";
        if (externalSystemId === undefined || externalSystemId === null)
            throw new Error("The parameter 'externalSystemId' must be defined and cannot be null.");
        else
            url_ += "ExternalSystemId=" + encodeURIComponent("" + externalSystemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetpersonproductholdings(_response);
        });
    }

    protected processGetpersonproductholdings(response: Response): Promise<ApiResponse<PersonProductHolding[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonProductHolding[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Person does not exist in shield", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<PersonProductHolding[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * UtilityUpdatePerson
     * @param personId The person/crm id of the person to be updated.
     * @param shieldEnvironment Target shield environment
     * @param personRequest (optional) 
     * @return Person details
     */
    utilityupdateperson(personId: string, shieldEnvironment: string, personRequest?: PersonRequest | null | undefined): Promise<ApiResponse<Person>> {
        let url_ = this.baseUrl + "/utility/person/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUtilityupdateperson(_response);
        });
    }

    protected processUtilityupdateperson(response: Response): Promise<ApiResponse<Person>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Person;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Person does not exist in the mock", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Person>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * UtilityCreatePerson
     * @param shieldEnvironment Target shield environment
     * @param personRequest (optional) 
     * @return Person created
     */
    utilitycreateperson(shieldEnvironment: string, personRequest?: PersonRequest | null | undefined): Promise<ApiResponse<Person>> {
        let url_ = this.baseUrl + "/utility/person";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUtilitycreateperson(_response);
        });
    }

    protected processUtilitycreateperson(response: Response): Promise<ApiResponse<Person>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Person;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Person>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * SetRoadsideAssistance
     * @param shieldEnvironment Target shield environment
     * @param setRoadsideAssistanceRequest (optional) The details used to set the roadside assistance for member.
     * @return No content
     */
    setroadsideassistance(shieldEnvironment: string, setRoadsideAssistanceRequest?: SetRoadsideAssistanceRequest | null | undefined): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/roadside";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setRoadsideAssistanceRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetroadsideassistance(_response);
        });
    }

    protected processSetroadsideassistance(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found - contact has not been previously created within the mock.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * CreateOrganisation
     * @param shieldEnvironment Target shield environment
     * @param organisationRequest (optional) 
     * @return Organisation created
     */
    createorganisation(shieldEnvironment: string, organisationRequest?: OrganisationRequest | null | undefined): Promise<ApiResponse<Person>> {
        let url_ = this.baseUrl + "/organisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organisationRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateorganisation(_response);
        });
    }

    protected processCreateorganisation(response: Response): Promise<ApiResponse<Person>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Person;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Person>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * SearchOrganisations
     * @param shieldEnvironment Target shield environment
     * @return Retrieved successfully.
     */
    searchorganisations(shieldEnvironment: string): Promise<ApiResponse<MockOrganisation[]>> {
        let url_ = this.baseUrl + "/organisation/search";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchorganisations(_response);
        });
    }

    protected processSearchorganisations(response: Response): Promise<ApiResponse<MockOrganisation[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MockOrganisation[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<MockOrganisation[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetOrganisationByShieldContactId
     * @param externalSystemId The shield contact id for the organisation
     * @param shieldEnvironment Target shield environment
     * @return Organisation details
     */
    getorganisationbyshieldcontactid(externalSystemId: string, shieldEnvironment: string): Promise<ApiResponse<Person>> {
        let url_ = this.baseUrl + "/get-organisation?";
        if (externalSystemId === undefined || externalSystemId === null)
            throw new Error("The parameter 'externalSystemId' must be defined and cannot be null.");
        else
            url_ += "ExternalSystemId=" + encodeURIComponent("" + externalSystemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "ShieldEnvironment": shieldEnvironment !== undefined && shieldEnvironment !== null ? "" + shieldEnvironment : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetorganisationbyshieldcontactid(_response);
        });
    }

    protected processGetorganisationbyshieldcontactid(response: Response): Promise<ApiResponse<Person>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Person;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Organisation does not exist in shield", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<Person>>(new ApiResponse(status, _headers, null as any));
    }
}

/** Contains the details regarding the error. */
export interface ErrorDto {
    /** The code of the error message. */
    code?: string | undefined;
    /** The error message. */
    message?: string | undefined;
}

/** Contains list of matching members. */
export interface MockMember {
    /** The shield contact identifier (e.g."123412"). */
    contactId?: number | undefined;
    /** Generated mock member central guid. */
    crmId?: string | undefined;
}

export interface SetMatchStatus {
}

export interface SetIsAliveStatus {
}

export interface SetStatusOverrideStatus {
}

export interface SetProductHoldingStatus {
}

/** Contains list of matching organisations. */
export interface MockOrganisation {
    /** The shield contact identifier (e.g."123412"). */
    contactId?: number | undefined;
    /** Generated mock member central guid. */
    crmId?: string | undefined;
}

export interface Address {
    buildingName?: string | undefined;
    subBuildingNumber?: string | undefined;
    blockNumber?: string | undefined;
    unitNumber?: string | undefined;
    lotNumber?: string | undefined;
    houseNumber?: string | undefined;
    streetName?: string | undefined;
    poBox?: string | undefined;
    suburb?: string | undefined;
    state?: string | undefined;
    postcode?: string | undefined;
    country?: string | undefined;
    qasValidated?: boolean | undefined;
    formattedAddress?: string | undefined;
}

export interface Person {
    personId?: string | undefined;
    racId?: string | undefined;
    preferredShieldContactId?: string | undefined;
    tier?: string | undefined;
    cardIssueNumber?: string | undefined;
    membershipCardNumber?: string | undefined;
    barcode?: string | undefined;
    tenure?: number | undefined;
    membershipType?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    surname?: string | undefined;
    initials?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: string | undefined;
    mobilePhone?: string | undefined;
    homePhone?: string | undefined;
    workPhone?: string | undefined;
    personalEmailAddress?: string | undefined;
    workEmailAddress?: string | undefined;
    loginEmailAddress?: string | undefined;
    loginObjectId?: string | undefined;
    postalAddress?: Address | undefined;
    okToMarket?: boolean | undefined;
    suspendMail?: boolean | undefined;
    hearingImpaired?: boolean | undefined;
    interpreterRequired?: string | undefined;
    passPhrase?: string | undefined;
    horizons?: string | undefined;
    suspendHorizons?: boolean | undefined;
    discountOutcome?: string | undefined;
    amsToProcess?: boolean | undefined;
    deceased?: string | undefined;
    preferredName?: string | undefined;
    nextTenureUpdate?: string | undefined;
    memberJoinDate?: string | undefined;
    anniversaryDate?: string | undefined;
    eligibleToVote: boolean;
    personSystemIds?: PersonSystemId[] | undefined;
    isMember: boolean;
}

export interface PersonRequest {
    personId?: string | undefined;
    racId?: string | undefined;
    tier?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    surname?: string | undefined;
    initials?: string | undefined;
    preferredName?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: string | undefined;
    mobilePhone?: string | undefined;
    homePhone?: string | undefined;
    workPhone?: string | undefined;
    personalEmailAddress?: string | undefined;
    workEmailAddress?: string | undefined;
    okToMarket?: boolean | undefined;
    loginEmailAddress?: string | undefined;
    loginObjectId?: string | undefined;
    address?: Address | undefined;
    postalAddress?: Address | undefined;
    personSystemIds?: PersonSystemId[] | undefined;
}

export interface OrganisationRequest {
    organisationName?: string | undefined;
    workPhoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    workEmail?: string | undefined;
    postalAddress?: Address | undefined;
}

/** Contains the product holding details for the person. */
export interface PersonProductHolding {
    /** Timestamp in UTC */
    timestamp?: string | undefined;
    /** The product holding payload. */
    payload?: string | undefined;
}

/** A system ID. */
export interface PersonSystemId {
    system: string;
    systemId: string;
}

export interface SetRoadsideAssistanceRequest {
}

export class ApiResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}